import { render, staticRenderFns } from "./AddressFormGroup.vue?vue&type=template&id=f2be390c"
import script from "./AddressFormGroup.vue?vue&type=script&lang=js"
export * from "./AddressFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports